<template>
  <div class="columns is-centered  is-mobile">
    <div class="column login-form-wrapper">
      <div class="login-form">
        <div class="login-form__icon">
          <b-icon pack="far" icon="user-circle"></b-icon>
        </div>
        <div class="login-form__title">Reset your password:</div>
        <div class="login-form__subtitle_bold">{{ email }}</div>
        <ValidationObserver v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <div class="login-form__item">
              <validation-provider name="New Password"
                    :bails="false"
                    v-slot="{ errors }"
                    vid="password"
                    :rules="'required|min_password_length:8|max:32|lower_case_letter|' +
                            'upper_case_letter|numeric_letter|without_spaces|password'">
                <b-field label="New Password" :type="{ 'is-danger':errors.length }"
                         class="password-field"
                         :message="errors[0]">
                  <template slot="label">
                    New Password
                    <b-tooltip :label="passwordHint"
                               class="block-tooltip is-gray"
                               type="is-info"
                               :delay="200"
                               :size="windowWidth <= 760 ? 'is-small' : 'is-large'"
                               animated
                               multilined>
                      <b-icon pack="fa" size="is-small" icon="question-circle">
                      </b-icon>
                    </b-tooltip>
                  </template>
                  <b-input size="is-medium"
                           ref="password"
                           custom-class="input-password"
                           autocomplete="new-password"
                           :password-reveal="isPasswordFocused"
                           @focus="passwordFocused"
                           v-model="password" type="password" maxlength="32"></b-input>
                </b-field>
              </validation-provider>
            </div>

            <div class="login-form__item">
              <validation-provider
                name="Password Confirmation"
                v-slot="{ errors }" rules="required|confirmed:password">
                  <b-field label="Password Confirmation" :type="{ 'is-danger':errors.length }"
                           class="password-field"
                           :message="errors[0]">
                  <b-input size="is-medium"
                           ref="passwordConfirm"
                           custom-class="input-password-confirm"
                           autocomplete="new-password"
                           :password-reveal="isPasswordConfirmFocused"
                           @focus.stop="passwordConfirmFocused"
                           v-model="passwordConfirm" type="password" maxlength="32"></b-input>
                </b-field>
              </validation-provider>
            </div>

            <div class="login-form__item">
              <p class="control">
                <button class="button is-success submit-button" type="submit">
                  RESET PASSWORD
                </button>
              </p>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { RESTORE_LINK_DECRYPT, UPDATE_PASSWORD } from '../store/modules/auth/actions';
import { SET_SPLASH, SET_PRELOADER } from '../store/mutations';

export default {
  name: 'NewPassword',

  data() {
    return {
      PASSWORD_REGEXP: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z~!@#$%&()\-_+={}[\]|\\;:<>,./?\d]{8,}$/,
      password: '',
      passwordConfirm: '',
      isShort: false,
      isEqual: true,
      firstname: '',
      lastname: '',
      email: '',
      invalidLink: false,
      windowWidth: window.innerWidth,
      isPasswordFocused: false,
      isPasswordConfirmFocused: false,
    };
  },

  beforeMount() {
    const enc = this.$route.query.m;
    if (!enc) this.$router.push('/login');

    this.splash(true);
    this.linkDecrypt({ enc }).then((response) => {
      this.firstname = response.firstname;
      this.lastname = response.lastname;
      this.email = response.email;
    }).catch(() => {
      this.$buefy.toast.open({
        message: 'Invalid link',
        type: 'is-danger',
        duration: 5000,
      });
      this.$router.push('/login');
    }).finally(() => this.splash(false));
  },

  computed: {
    ...mapGetters(['passwordHint']),
  },
  methods: {
    ...mapMutations({
      splash: SET_SPLASH,
      preloader: SET_PRELOADER,
    }),
    ...mapActions('auth2', {
      linkDecrypt: RESTORE_LINK_DECRYPT,
      updatePassword: UPDATE_PASSWORD,
    }),
    submit() {
      const newPassword = this.password;
      const enc = this.$route.query.m;

      this.preloader(true);
      this.updatePassword({ newPassword, enc }).then(() => {
        this.$buefy.toast.open({
          message: 'Thank you! <br /> <small>Your password successfully changed</small>',
          type: 'is-success',
          duration: 5000,
        });
        this.$router.push('/login');
      }).catch((error) => {
        this.$buefy.toast.open({
          message: this.lodash.get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com'),
          type: 'is-danger',
          duration: 10000,
        });
      }).finally(() => this.preloader(false));
    },
    passwordFocused() {
      this.isPasswordFocused = true;
      this.isPasswordConfirmFocused = false;
      if (this.$refs.passwordConfirm.isPasswordVisible) {
        this.$refs.passwordConfirm.isPasswordVisible = false;
        this.$refs.passwordConfirm.newType = 'password';
      }
    },
    passwordConfirmFocused() {
      this.isPasswordFocused = false;
      this.isPasswordConfirmFocused = true;
      if (this.$refs.password.isPasswordVisible) {
        this.$refs.password.isPasswordVisible = false;
        this.$refs.password.newType = 'password';
      }
    },
  },

};
</script>

<style scoped lang="stylus">
@require "../assets/style/modern/variables.styl";
.login-form-wrapper >>> input.input-password,
.login-form-wrapper >>> input.input-password-confirm
  font-size 16px
  height 48px
  &[type="password"]::-ms-reveal
    display none
.login-form-wrapper
  display flex
  justify-content center
  padding-right 0
  .password-field >>> i.mdi:is(.mdi-eye,.mdi-eye-off)
    color #8FA7B3
  .password-field >>>
    .label
      font-weight 500
    p.help
      font-size 16px
    span.icon.is-right
      height 48px
  span.block-tooltip.b-tooltip::after
    white-space pre-line
    text-align left
    left 30px
    width 285px!important
  .login-form
    @media (max-width: $breakpoints.md)
      padding 30px 16px
    max-width 750px
    margin 20px 20px 0 20px
    width 100%;
    background white
    border-radius 6px
    padding 30px 55px
    box-shadow 0 18px 32px rgba(156, 173, 173, 0.2);
    color #293033
    &__icon, &__title, &__subtitle, &__subtitle_bold
      text-align center
    &__item
      margin-bottom 10px
      p.control
        text-align center
    &__icon
      margin-bottom 15px
      color: #17B548
      font-size 2rem
    &__title
      font-weight bold
      font-size 28px
      margin-bottom 10px
      color #293033
    &__subtitle, &__subtitle_bold
      margin-bottom 30px
      font-size 18px
      color #293033
    &__subtitle_bold
      font-weight bold
    &__link
      color #188DFC
      text-align center
      & a
        color #188DFC
        margin 0 10px
        &:hover
          text-decoration underline
  .submit-button
    font-size 20px
    height 48px
    margin-top 5px
    background #68BA62
    max-width 240px
    min-width 100px
    width 100%
    @media (max-width: $breakpoints.md)
      font-size 16px
      max-width unset
      min-width unset
  .login
    background #0743bf1c
    padding 15px
    border-radius 6px
  .help-pass
    z-index -999999
    position absolute
    margin-top -50px
    border none
    color transparent
</style>
